<template>
  <v-container
    fluid
  >
    <v-row
    >
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="6"
        lg="6"
        xl="3"
      >
        <Rufgruppe_beantragen @open-ticket="$emit('open-ticket', $event)"></Rufgruppe_beantragen>
      </v-col>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="6"
        lg="6"
        xl="3"
      >
        <LockPermissions @open-ticket="$emit('open-ticket', $event)"></LockPermissions>
      </v-col>
      <v-spacer></v-spacer>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        lg="12"
        xl="6"

      >
        <l-map
          style="height:700px; z-index: 0"
          :zoom="13"
          :center="[52.439, 9.568]"
          :scrollWheelZoom="false"
        >
          <l-tile-layer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <l-marker
            v-for="obj in filtered_cis"
            :key="obj.id"
            :lat-lng="[obj.lat, obj.lon]"
            :icon="createIcon(obj)[0]"
            :z-index-offset="createIcon(obj)[1]"
            @click="$emit('open-ci', obj.id)"
          >
            <l-tooltip>
              <div>
                <b>{{ obj.name }}</b>
                <br>
                Status: {{ obj.status }}
              </div>
            </l-tooltip>
          </l-marker>
        </l-map>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import L from "leaflet"
import { LMap, LTileLayer, LMarker, LTooltip } from "vue2-leaflet"

import "leaflet/dist/leaflet.css"
import LockPermissions from "../widgets/LockPermissions.vue";
import Rufgruppe_beantragen from "../widgets/Rufgruppe_beantragen.vue";

export default {
  name: "Home",

  components: {
    Rufgruppe_beantragen,
    LockPermissions,
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
  },
  methods: {
    createIcon(obj) {

      let color = "grey";
      let icon = "mdi-help";
      let z_index = 0;

      if (obj.status === "OK"){ color = "green"; z_index=100}
      else if (obj.status === "WARNING"){ color = "orange"; z_index=200}
      else if (obj.status === "OUTAGE"){ color = "red"; z_index=300}
      else if (obj.status === "POWER_OUTAGE"){ color = "black"; z_index=400}
      else{ color = "blue"; z_index=500}

      if(obj.type === "STATION"){
        icon = "mdi-fire-station"
      }
      else if(obj.type === "SIRENE"){
        icon = "mdi-air-horn"

      }
      const result = (L.divIcon({
        className: "custom-marker",
        html: `
          <div style="
            background:white;
            border: 2.5px solid ${color};
            border-radius:50%;
            padding:4px;
            box-shadow:0 0 4px rgba(0,0,0,0.4);
          ">
            <i class="v-icon notranslate mdi ${icon} theme--light ${color}--text"></i>
          </div>
        `,
        iconSize: [35, 35],
        iconAnchor: [15, 15]
      }));
      return [result, z_index]
    }
  },
  computed: {
    filtered_cis() {
      return this.$store.state.ticketsystem.cis.filter(ci => ci.status && ci.lat != null && ci.lon != null)
    }
  },
  data() {
    return {
      objects: [
        {
          id: 1,
          name: "Server 1",
          status: "online",
          lat: 52.3759,
          lng: 9.7320
        },
        {
          id: 2,
          name: "Server 2",
          status: "offline",
          lat: 52.38,
          lng: 9.74
        }
      ]
    };
  },
  mounted() {
    if(this.$store.state.ticketsystem.cis.length === 0)
      this.$store.dispatch("update", { "context": "/cis" })
  }
};
</script>